import React, { useEffect, useState, Fragment, useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import CardSection from 'components/sales/cardSection/cardSection';
import DivLayout from 'components/sales/divLayout/divLayout';
import ModalPop from 'components/sales/modal/modal';
import { Link } from 'react-router-dom';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import { Button } from 'react-bootstrap';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import FileUpload from 'components/sales/fileUpload/fileUpload';
import DocumentView from 'components/sales/downloadDocView/documentView';

const ViewRmTicket = ({
  fetchEmTicketDetails,
  employeeTicketDetails,
  postUpdateEMStatus,
  documentUploadUrl,
  postEmployeeRemark,
  match,
  fetchEmTicketStatus,
  employeeStatus,
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [assigneeId, setAssigneeId] = useState('');
  const [isRoleId, setIsRoleId] = useState([]);
  const [remarkData, setRemarkData] = useState({
    em_ticket_id: match.params.id,
    remarks: '',
    attachment: '',
  });
  const [successModal, setSuccessModal] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      (async () => {
        const roles = await JSON.parse(localStorage.getItem('roles'));
        roles.map((obj) => isRoleId.push(obj.id));
        setIsRoleId(isRoleId);
      })();
    }, 1000);
  }, []);

  const handleModalHide = () => setIsModal(false);

  const headerBtns = () => {
    return (
      <Fragment>
        <Button
          className=" btn btn-transparent"
          onClick={() => setIsModal(true)}
        >
          {localization.changeStatus}
        </Button>
        <Link
          to={`/dashboard/em-assign-ticket/${
            employeeTicketDetails.ticket &&
            employeeTicketDetails.ticket.ticket_id
          }`}
          className="btn btn-primary"
        >
          {localization.assignEngineer}
          <img src={Images?.ArrowRight} alt=""></img>
        </Link>
        <Link
          to={`/dashboard/mrf/em/${match.params.id}/${
            employeeTicketDetails.ticket && employeeTicketDetails.ticket.site_id
          }`}
          className="btn btn-primary"
        >
          {localization.createMRF}
          <img src={Images?.ArrowRight} alt=""></img>
        </Link>
      </Fragment>
    );
  };

  useEffect(() => {
    (async () => {
      if (fetchEmTicketDetails) {
        setIsLoading(true);
        await fetchEmTicketDetails(match.params.id);
        await fetchEmTicketStatus();
        setIsLoading(false);
      }
    })();
  }, [fetchEmTicketDetails]);

  const saveReply = async () => {
    if (remarkData.remarks !== '') {
      const res = await postEmployeeRemark(remarkData);
      if (res === true) {
        setIsLoading(true);
        setSuccessModal(true);
        await fetchEmTicketDetails(match.params.id);
        setIsLoading(false);
      }
    }
  };

  useEffect(() => {
    (() => {
      if (successModal === true) {
        setRemarkData({
          rm_ticket_id: match.params.id,
          remarks: '',
          attachment: '',
        });
      }
    })();
  }, [successModal]);

  const updatePMStatus = async () => {
    const data = {
      em_ticket_id: match.params.id,
      status: assigneeId,
    };
    if (assigneeId != '') {
      const res = await postUpdateEMStatus(data);
      if (res === true) {
        setIsModal(false);
        setIsLoading(true);
        await fetchEmTicketDetails(match.params.id);
        setIsLoading(false);
      }
    }
  };

  return (
    <Layout
      title={localization.ticketDetails}
      Buttons={match.path.includes('em-view/') ? () => {} : headerBtns}
      isLoading={isLoading}
      isGoback
      linkUrl={
        match.path.includes('em-view/')
          ? `${baseUrl}/approvals/em-tickets`
          : `${baseUrl}/em-tickets`
      }
    >
      <CardSection title={localization.employeeTicket}>
        <div className="details-listing">
          <DivLayout
            heading={localization.ticketId}
            data={
              employeeTicketDetails.ticket &&
              employeeTicketDetails.ticket.ticket_id
            }
          />
          <DivLayout
            heading={localization.createdOn}
            data={
              employeeTicketDetails.ticket &&
              employeeTicketDetails.ticket.created_on &&
              employeeTicketDetails.ticket.created_on.slice(0, 10)
            }
          />
          <DivLayout
            heading={localization.raisedBy}
            data={
              employeeTicketDetails.ticket &&
              employeeTicketDetails.ticket.created_by
            }
          />
          <DivLayout
            heading={localization.siteNumber}
            data={
              employeeTicketDetails.ticket &&
              employeeTicketDetails.ticket.site_no
            }
          />
          <DivLayout
            heading={localization.siteType}
            data={
              employeeTicketDetails.ticket &&
              employeeTicketDetails.ticket.site_type
            }
          />

          <DivLayout
            heading={localization.clientName}
            data={
              employeeTicketDetails.ticket &&
              employeeTicketDetails.ticket.client_name
            }
          />
          <DivLayout
            heading={localization.assignedTo}
            data={
              employeeTicketDetails.ticket &&
              employeeTicketDetails.ticket.assigned_to &&
              employeeTicketDetails.ticket.assigned_to.name
            }
          />
          <DivLayout
            heading={localization.status}
            data={
              employeeTicketDetails.ticket &&
              employeeTicketDetails.ticket.status
            }
          />
          
          {employeeTicketDetails.ticket && (employeeTicketDetails.ticket.attachment.map((document) => (
             <DocumentView attachment={document} />
            )))}

          {employeeTicketDetails &&
            employeeTicketDetails.mrf_details &&
            employeeTicketDetails.mrf_details.length > 0 && (
              <Fragment>
                <h5 className="full-width">{localization.mrf}</h5>
                <table className="panel-table faq-listing">
                  <thead>
                    <tr>
                      <th>{'MRF ID'}</th>
                      <th>{localization.createdOn}</th>
                      <th>{localization.plannedDeliveryDate}</th>
                      <th>{localization.status}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {employeeTicketDetails.mrf_details.map((obj, index) => {
                      return (
                        <tr key={index}>
                          <td>
                            <span className="th">{'MRF ID'}</span>
                            {obj.mrf_id}
                          </td>
                          <td>
                            <span className="th">{localization.createdOn}</span>
                            {obj.created_at}
                          </td>
                          <td>
                            <span className="th">
                              {localization.plannedDeliveryDate}
                            </span>
                            {obj.planned_delivery_date
                              ? obj.planned_delivery_date
                              : localization.na}
                          </td>
                          <td>
                            <span className="th">{localization.status}</span>
                            {obj.status}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </Fragment>
            )}
        </div>
      </CardSection>

      {/* For later use */}
      {employeeTicketDetails.remarks &&
        employeeTicketDetails.remarks.length > 0 && (
          <CardSection title={localization.replies}>
            <div className="details-listing">
              {employeeTicketDetails.remarks &&
                employeeTicketDetails.remarks.length > 0 &&
                employeeTicketDetails.remarks.map((obj) => {
                  return (
                    <div className="details-listing reply-box">
                      <div className="details-byline">
                        <div className="details-list">
                          <strong className="data-title">
                            {localization.replyDate}
                          </strong>
                          <span className="data-details">
                            {obj.created_at.slice(0, 10)}
                          </span>
                        </div>
                        <div className="details-list">
                          <strong className="data-title d-none d-md-block">
                            {localization.repliedBy}
                          </strong>
                          <span className="data-details">
                            <span className="d-md-none">By </span>
                            {obj.replied_by}
                          </span>
                        </div>
                      </div>
                      <div className="details-list full-width">
                        <DivLayout
                          heading={localization.response}
                          data={obj.remarks}
                        />
                      </div>
                      {/* {obj.attachment && (
                        <div className="details-list full-width">
                          <DocumentView attachment={obj.attachment} />
                        </div>
                      )} */}
                       {obj.attachment && (obj.attachment.map((document) => (
                               <DocumentView attachment={document} />
                        )))}    
                    </div>
                  );
                })}
            </div>
          </CardSection>
        )}

      <CardSection title={localization.reply}>
        <form>
          <div className="form-group full-width">
            <ConstantInput
              label={localization.enterReplyDescription}
              type="text"
              value={remarkData.remarks}
              handleChange={(val) =>
                setRemarkData({ ...remarkData, remarks: val })
              }
            />
          </div>
          <div className="form-group form-btn">
            <FileUpload
              id="attactment"
              multiple="multiple"
              reset={successModal}
              accept=".pdf,.png,.jpg,.jpeg,.doc"
              documentUploadUrl={documentUploadUrl}
              onChange={(val) =>
                setRemarkData({ ...remarkData, attachment: val })
              }
            >
              <span className="btn btn-transparent">
                {localization.uploadMultiAttachment}
              </span>
            </FileUpload>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => {
                saveReply();
              }}
            >
              {localization.reply} <img src={Images?.ArrowRight} alt="" />
            </button>
          </div>
        </form>
      </CardSection>

      <ModalPop
        title={localization.changeStatus}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <h5>{localization.pleaseConfirmStatus}</h5>
          <DropDownInput
            label={localization.selectStatus}
            required
            isStarRequired={true}
            data={
              isRoleId.includes(9)
                ? [{ id: 3, name: 'Closed' }]
                : employeeStatus
            }
            errorMsg={localization.isRequired}
            getIdValue={(val) => setAssigneeId(val.id)}
          />

          <Button
            className="btn btn-primary mb-4"
            onClick={() => updatePMStatus()}
          >
            {localization.continue} <img src={Images?.ArrowRight} alt="" />
          </Button>
        </div>
      </ModalPop>

      <ModalPop
        title={localization.conf}
        show={successModal}
        handleModalHide={() => {
          setSuccessModal(false);
        }}
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.rejectSuccessfully}</h5>
          <Button
            onClick={() => {
              setSuccessModal(false);
            }}
            className="btn btn-primary mb-4"
          >
            {localization.continue} <img src={Images?.ArrowRight} alt="" />
          </Button>
        </div>
      </ModalPop>
    </Layout>
  );
};

export default ViewRmTicket;
